import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { sanitizeMonthKey } from "@/lib/period-search";
import { appRoute } from "./route";

const ProjectDetailPage = lazy(async () => {
  const m = await import("@/features/projects/components/project-detail-page");
  return { default: m.ProjectDetailPage };
});

function ProjectDetailPageWrapper() {
  return (
    <Suspense fallback={null}>
      <ProjectDetailPage />
    </Suspense>
  );
}

interface ProjectDetailSearch {
  /** Filtro de periodo: mes contable navegado (`YYYY-MM`); ausente = todo el historial. */
  month?: string;
}

/** validateSearch: detail filtered period lives in the URL (shareable). */
function sanitizeProjectDetailSearch(search: Record<string, unknown>): ProjectDetailSearch {
  return { month: sanitizeMonthKey(search.month) };
}

export const projectDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/projects/$projectId",
  validateSearch: sanitizeProjectDetailSearch,
  component: ProjectDetailPageWrapper,
});
